import { IconProps } from '@diritto/common/style/icon';

const BadgeRatio = 8 / 9;
export const UpBadgeIcon = ({ size = 18 }: IconProps) => (
  <svg
    width={size}
    height={size * BadgeRatio}
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexGrow: 0, flexShrink: 0 }}>
    <rect width="18" height="16" rx="2" fill="#2EA3FF" />
    <path
      d="M4.60001 4.59998V8.91998C4.60001 9.39331 4.72335 9.75664 4.97001 10.01C5.21668 10.2566 5.56335 10.38 6.01001 10.38C6.46335 10.38 6.81335 10.2566 7.06001 10.01C7.30668 9.75664 7.43001 9.39331 7.43001 8.91998V4.59998H8.84001V8.90998C8.84001 9.50331 8.71001 10.0066 8.45001 10.42C8.19668 10.8266 7.85335 11.1333 7.42001 11.34C6.99335 11.5466 6.51668 11.65 5.99001 11.65C5.47001 11.65 4.99668 11.5466 4.57001 11.34C4.15001 11.1333 3.81668 10.8266 3.57001 10.42C3.32335 10.0066 3.20001 9.50331 3.20001 8.90998V4.59998H4.60001Z"
      fill="white"
    />
    <path
      d="M15.2827 6.75998C15.2827 7.13331 15.1927 7.48331 15.0127 7.80998C14.8393 8.13664 14.5627 8.39998 14.1827 8.59998C13.8093 8.79998 13.336 8.89998 12.7627 8.89998H11.5927V11.58H10.1927V4.59998H12.7627C13.3027 4.59998 13.7627 4.69331 14.1427 4.87998C14.5227 5.06664 14.806 5.32331 14.9927 5.64998C15.186 5.97664 15.2827 6.34664 15.2827 6.75998ZM12.7027 7.76998C13.0893 7.76998 13.376 7.68331 13.5627 7.50998C13.7493 7.32998 13.8427 7.07998 13.8427 6.75998C13.8427 6.07998 13.4627 5.73997 12.7027 5.73997H11.5927V7.76998H12.7027Z"
      fill="white"
    />
  </svg>
);
